import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from 'rxjs';
import { memo } from "../util/index.js";
export function votesOf(instanceId, api) {
  return memo(instanceId, function (accountId) {
    return api.derive.council.votes().pipe(map(function (votes) {
      return (votes.find(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            from = _ref2[0];

        return from.eq(accountId);
      }) || [null, {
        stake: api.registry.createType('Balance'),
        votes: []
      }])[1];
    }));
  });
}